import {Injectable} from '@angular/core';

@Injectable()
export class ViewStateService  {
  viewState : Map<string, Map<string, string> > = new Map<string, Map<string, string> >();
  constructor(){
  }

  setViewState(key : string , map : Map<string, string>){
    this.viewState.set(key, map);
   // console.log("key"+JSON.stringify(key));
   // console.log("map"+JSON.stringify(map));
  }

  getViewState(key : string) : Map<string, string>{
    return this.viewState.get(key);
  }
}


// WEBPACK FOOTER //
// ./src/app/providers/viewstate.ts